/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Hero_Save_TimeInputs */

const en_auth_hero_save_time = /** @type {(inputs: Auth_Hero_Save_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save time`)
};

const es_auth_hero_save_time = /** @type {(inputs: Auth_Hero_Save_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahorra tiempo`)
};

/**
* | output |
* | --- |
* | "Save time" |
*
* @param {Auth_Hero_Save_TimeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_hero_save_time = /** @type {((inputs?: Auth_Hero_Save_TimeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Hero_Save_TimeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_hero_save_time(inputs)
	return en_auth_hero_save_time(inputs)
});